"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_synchronisation_1 = require("../js-synchronisation");
const js_createTransaction_1 = __importDefault(require("../js-createTransaction"));
const js_prepareTransaction_1 = __importDefault(require("../js-prepareTransaction"));
const js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
const js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
const js_signOperation_1 = __importDefault(require("../js-signOperation"));
const js_broadcast_1 = __importDefault(require("../js-broadcast"));
const cache_1 = require("./../cache");
const logic_1 = require("../logic");
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const jsHelpers_2 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const serialization_1 = require("../serialization");
const deviceAccess_1 = require("../../../hw/deviceAccess");
const hw_app_btc_1 = __importDefault(require("@ledgerhq/hw-app-btc"));
const rxjs_1 = require("rxjs");
const receive = (0, jsHelpers_1.makeAccountBridgeReceive)({
    injectGetAddressParams: account => {
        const perCoin = logic_1.perCoinLogic[account.currency.id];
        if (perCoin && perCoin.injectGetAddressParams) {
            return perCoin.injectGetAddressParams(account);
        }
    },
});
const updateTransaction = (tx, patch) => {
    const updatedT = (0, jsHelpers_2.defaultUpdateTransaction)(tx, patch);
    // We accept case-insensitive addresses as input from user,
    // but segwit addresses need to be converted to lowercase to be valid
    if (updatedT.recipient.toLowerCase().indexOf("bc1") === 0) {
        updatedT.recipient = updatedT.recipient.toLowerCase();
    }
    return updatedT;
};
const signerContext = (deviceId, crypto, fn) => (0, deviceAccess_1.withDevice)(deviceId)(transport => (0, rxjs_1.from)(fn(new hw_app_btc_1.default({ transport, currency: crypto.id })))).toPromise();
const currencyBridge = {
    scanAccounts: (0, js_synchronisation_1.scanAccounts)(signerContext),
    preload: () => Promise.resolve({}),
    hydrate: () => { },
};
const accountBridge = {
    estimateMaxSpendable: js_estimateMaxSpendable_1.default,
    createTransaction: js_createTransaction_1.default,
    prepareTransaction: js_prepareTransaction_1.default,
    updateTransaction,
    getTransactionStatus: js_getTransactionStatus_1.default,
    receive,
    sync: (0, js_synchronisation_1.sync)(signerContext),
    signOperation: js_signOperation_1.default,
    broadcast: ({ account, signedOperation }) => __awaiter(void 0, void 0, void 0, function* () {
        cache_1.calculateFees.reset();
        return (0, js_broadcast_1.default)({
            account,
            signedOperation,
        });
    }),
    assignFromAccountRaw: serialization_1.assignFromAccountRaw,
    assignToAccountRaw: serialization_1.assignToAccountRaw,
};
exports.default = {
    currencyBridge,
    accountBridge,
};
//# sourceMappingURL=js.js.map